import React, { forwardRef } from "react";

import classNames from "classnames";

import { ITypographyProps, Typography } from "../Typography/Typography";

export interface ILabelProps {
  invalid?: boolean;
  required?: boolean;
  size?: "regular" | "small";
  htmlFor?: string;
}

export const Label = forwardRef<
  HTMLLabelElement,
  ILabelProps & Omit<ITypographyProps, keyof ILabelProps | "variant" | "color">
>(
  (
    {
      invalid = false,
      required = false,
      size = "regular",
      children,
      className,
      weight = "bold",
      htmlFor,
      ...props
    },
    ref
  ) => {
    const color = invalid ? "alert" : "primary";
    const variant = size === "regular" ? "Body 2" : "Caption 1";

    return (
      <Typography
        as="label"
        className={classNames("c-label", className)}
        variant={variant}
        color={color}
        weight={weight}
        ref={ref}
        htmlFor={htmlFor}
        {...props}
      >
        {children}
        {required ? "*" : null}
      </Typography>
    );
  }
);

Label.displayName = "Label";
